import { BaseTicketController } from '../../../../common/base/ticketController';

export class ClosedController extends BaseTicketController {
  constructor(controllerService, ticketService, ticketFlowService) {
    'ngInject';
    super({ controllerService, ticketService, ticketFlowService });
  }

  $onInit() {
    super.$onInit();
  }

  navigateToList() {
    const state = this.ticketFlowService.getRouteForTicket(this.ticket, 'list');
    this.go(state);
  }
}
